import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationConstants } from '../../providers/application-constants';

@Component({
  selector: 'app-return-type',
  templateUrl: './return-type.component.html',
  styleUrls: ['./return-type.component.css']
})
export class ReturnTypeComponent implements OnInit {

  constructor(private router: Router, private dialogRef: MatDialogRef<ReturnTypeComponent>,
    private applicationConstants: ApplicationConstants, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);
  }

  ngOnInit() {
  }

  invoice() {
    this.router.navigate(['sub_menu/1/invoice', { 'type': 'return_invoice' }]);
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
